const EventBar = () => {
  return (
    <div className=" relative w-full h-full bg-secondary px-[calc((100%-var(--container))/2)] 3xl:px-[calc((100%-var(--container)-100px))] py-4 lg:py-8 ">
      <div className=" relative w-full h-full grid xl:grid-cols-2 items-center gap-5 xl:gap-10">
        <div className=" relative w-full h-fit text-center xl:text-left">
          <h3 className="gmedium text-white 2xl:text-[1.8rem]">
            <span className="text-point">SOS도어락열쇠프로</span>
            <br className="block xl:hidden" />
            를&nbsp;이용하는&nbsp;4가지&nbsp;이유
          </h3>
        </div>
        <div className=" relative w-full h-full grid xl:grid-cols-2 gap-3">
          <div className=" relative w-full h-full grid grid-rows-2 gap-3">
            <div className=" relative w-full h-fit py-2 bg-white text-center rounded-full">
              <p className="text-lg 3xl:text-xl">
                문제에&nbsp;대한&nbsp;
                <span className="text-[var(--red-color)] font-bold">
                  근본적&nbsp;해결!
                </span>
              </p>
            </div>
            <div className=" relative w-full h-fit py-2 bg-white text-center rounded-full">
              <p className="text-lg 3xl:text-xl">
                <span className="text-[var(--red-color)] font-bold">
                  365일&nbsp;24시간
                </span>
                &nbsp;출동가능!
              </p>
            </div>
          </div>
          <div className=" relative w-full h-full grid grid-rows-2 gap-3">
            <div className=" relative w-full h-fit py-2 bg-white text-center rounded-full">
              <p className="text-lg 3xl:text-xl">
                수도권&nbsp;지역&nbsp;
                <span className="text-[var(--red-color)] font-bold">
                  1시간&nbsp;이내&nbsp;긴급출동
                </span>
              </p>
            </div>
            <div className=" relative w-full h-fit py-2 bg-white text-center rounded-full">
              <p className="text-lg 3xl:text-xl">
                정직한&nbsp;견적&nbsp;·&nbsp;확실한&nbsp;실력
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventBar;
